import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import DocumentList from './DocumentList';
import { useAuth } from '../utils/AuthContext';
import '../styles/styles.css';

const App = ({ isSignedIn, newDocument = null, onDocumentUpdate = () => { } }) => {
    const { authState, setAuthData } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [apiStatus, setApiStatus] = useState('');
    const [appLoading, setAppLoading] = useState(false);
    const [, setSelectedDocument] = useState(null);

    const safeAuthState = useMemo(() =>
        authState || { accessToken: '', userId: '', userName: '', supabaseRefreshToken: '', userEmail: '' },
        [authState]
    );

    useEffect(() => {
        console.log('[App] authState on mount');
        if (safeAuthState.accessToken || !safeAuthState.userId) {
            setAppLoading(false);
        }
    }, [safeAuthState]);

    useEffect(() => {
        console.log('[App] Location changed');
        if (!appLoading && !safeAuthState.accessToken && !['/success', '/cancel'].includes(location.pathname)) {
            navigate('/');
        }
    }, [safeAuthState, appLoading, navigate, location.pathname]);

    const startTimer = useCallback(() => null, []);

    const stopTimer = useCallback(() => { }, []);

    const handleSignIn = (userData) => {
        const accessTokenToUse = userData.accessToken;
        const refreshTokenToUse = userData.refreshToken;
        if (!accessTokenToUse) {
            console.error('[App] Sign-in failed: No access token');
            setAppLoading(false);
            return;
        }
        setAppLoading(true);
        setAuthData(
            userData.user_id,
            `${userData.firstname} ${userData.lastname}`,
            accessTokenToUse,
            refreshTokenToUse,
            userData.email,
            () => {
                setAppLoading(false);
                navigate('/');
            }
        );
    };

    const refreshDocuments = useCallback((newDoc) => {
        onDocumentUpdate(newDoc);
    }, [onDocumentUpdate]);

    const renderHomePage = () => (
        <div className="content-wrapper">
            {appLoading && (
                <div className="loading-overlay">
                    <div className="spinner"></div>
                </div>
            )}
            {apiStatus && (
                <div className="api-status-container">
                    <p className="api-status-text">{apiStatus}</p>
                </div>
            )}
            <DocumentList
                userId={safeAuthState.userId}
                setCurrentPage={(page, state) => {
                    const goTo = (path) => {
                        if (state) {
                            navigate(path, { state });
                        } else {
                            navigate(path);
                        }
                    };

                    if (page === 'QuizList') {
                        goTo('/quiz-list');
                    } else if (page === 'FlashcardList') {
                        goTo('/flashcard-list');
                    } else if (page === 'PodcastList') {
                        goTo('/podcast-list');
                    } else if (page === 'VideoList') {  // Added Video support
                        goTo('/video-list');
                    } else if (page === 'Upload') {
                        goTo('/upload');
                    } else {
                        goTo('/');
                    }
                }}
                setSelectedDocument={setSelectedDocument}
                newDocument={newDocument}
                accessToken={safeAuthState.accessToken}
                onSignIn={handleSignIn}
                supabaseRefreshToken={safeAuthState.supabaseRefreshToken || ''}
            />
        </div>
    );

    return renderHomePage();
};

export default App;